import React from 'react';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import './tile/Tile.scss';
import './AddCapsule.scss';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export function AddCapsule(props: { openAddCapsulePanel: () => void }) {
    const { openAddCapsulePanel } = props;
    const locked = useSelectLocked();

    if (locked) {
        return <></>;
    }

    return (
        <div
            className="AddCapsule tile-container"
            onClick={openAddCapsulePanel}
        >
            <div className="tile">
                <div className="add-capsule">
                    <Icon name="plus" />
                </div>
            </div>
        </div>
    );
}
